import React, { useEffect, useState } from 'react';
import Categories from './Categories';
import EnhancedTab from '../../../../lib/designSystem/TabSimulation';
import { useNavigate, useParams } from 'react-router-dom';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';

const tabs = [
  {
    index: 0,
    label: 'Categorías',
    component: <Categories />,
    path: 'categories',
  },
];

const TagsSettings = () => {
  const navigate = useNavigate();
  const { subPage } = useParams<{ subPage: string }>();
  const [loading, setLoading] = useState(true);
  const [companyTabs, setCompanyTabs] = useState<any>([]);
  const [startValue, setStartValue] = useState(0);

  const handleNavigation = (index: number) => {
    navigate(`/settings/tags/${companyTabs[index].path}`);
  };

  const setUpTabs = async () => {
    setLoading(true);
    const availableTabs: any = [...tabs];
    let startValueDefault = 0;
    startValueDefault = availableTabs.findIndex(
      (x: any) => x.path === subPage,
    );
    setCompanyTabs(availableTabs);
    setStartValue(startValueDefault === -1 ? 0 : startValueDefault);
    setLoading(false);
  };

  useEffect(() => {
    setUpTabs();
  }, []);

  if (loading) return <CenteredCircularProgress />;

  return (
    <div>
      <EnhancedTab
        tabType="secondary"
        startValue={startValue}
        tabs={companyTabs}
        onTabChange={handleNavigation}
      />
    </div>
  );
};

export default TagsSettings;
